// Imports
import { Route } from 'react-router-dom';
import Content from './resources/content';
import AccountSettings from './resources/content/pages/account/account-settings';
import Addresses from './resources/content/pages/account/account-settings/addresses';
import MemberSettings from './resources/content/pages/account/member-settings';
import Admin from './resources/content/pages/account/member-settings/admin';
import General from './resources/content/pages/account/member-settings/general';
import Password from './resources/content/pages/account/member-settings/password';
import MemberPrivacy from './resources/content/pages/account/member-settings/privacy';
import Profile from './resources/content/pages/account/member-settings/profile';
import Contact from './resources/content/pages/account/member-settings/contact';
import InsufficientPrivileges from './resources/content/pages/insufficient-privileges';
import NotFound from './resources/content/pages/not-found';
import Homepage from './resources/content/pages/page-types/homepage';
import PageTypesRoutes from './resources/content/pages/page-types/page-types-routes';
import MakePayment from './resources/content/pages/payments/make-payment';
import PaymentHistory from './resources/content/pages/payments/history';
import PaymentOptions from './resources/content/pages/payments/options';
import Surveys from './resources/content/pages/surveys';
import TakeSurvey from './resources/content/pages/surveys/take-survey';
import RequireAuthentication from './resources/shared-components/require-authentication';
import CommunicationsArchive from './resources/content/pages/account/communications-archive';
import Members from './resources/content/pages/account/account-settings/members';
import AccountPrivacy from './resources/content/pages/account/account-settings/privacy';
import Receipt from './resources/content/pages/payments/receipt';
import Register from './resources/content/pages/account/register';
import Methods from './resources/content/pages/payments/methods';
import HashRedirect from './hash-redirect';
import NewPassword from './resources/content/pages/account/new-password';


// Routes
const appRoutes = (
	<Route element={<Content />}>
		<Route index element={<Homepage />} />
		<Route path='/p/:partialURI' element={<PageTypesRoutes />}>
			<Route path='article/:articleIdentifier' />
			<Route path='recipe/:recipeIdentifier' />
			<Route path='account/:accountIdentifier' />
			<Route path='event/:eventAndOccurrenceIdentifier' />
			<Route path='topic/:topicIdentifier' />
			<Route path='listing/:listingIdentifier'>
				<Route path='edit' />
			</Route>
			<Route path='create' />
		</Route>
		
		<Route path='/account'>
			<Route path='register' element={<Register />} />
			<Route path='new-password' element={<NewPassword />} />
			<Route element={<RequireAuthentication />}>
				<Route path='account-settings' element={<AccountSettings />}>
					<Route index element={<HashRedirect defaultPath='addresses' />} />
					<Route path='addresses' element={<Addresses />} />
					<Route path='members' element={<Members />} />
					<Route path='privacy' element={<AccountPrivacy />} />
				</Route>
				<Route path='member-settings' element={<MemberSettings />}>
					<Route index element={<HashRedirect defaultPath='general' />} />
					<Route path='general' element={<General />} />
					<Route path='profile' element={<Profile />} />
					<Route path='password' element={<Password />} />
					<Route path='contact' element={<Contact />} />
					<Route path='privacy' element={<MemberPrivacy />} />
					<Route path='admin' element={<Admin />} />
				</Route>
				<Route path='communications/archive' element={<CommunicationsArchive />} />
			</Route>
			<Route index element={<NotFound />} />
		</Route>
		
		<Route element={<RequireAuthentication />}>
			<Route path='/surveys'>
				<Route index element={<Surveys />} />
				<Route path='take' element={<TakeSurvey />} />
			</Route>
		</Route>
		
		<Route element={<RequireAuthentication />}>
			<Route path='/payments'>
				<Route index element={<PaymentOptions />} />
				<Route path='pay' element={<MakePayment />} />
				<Route path='history' element={<PaymentHistory />} />
				<Route path='receipt/:paymentID' element={<Receipt />} />
				<Route path='methods' element={<Methods />} />
			</Route>
		</Route>
		
		<Route path='/insufficient-privileges' element={<InsufficientPrivileges title='Insufficient privileges' />}>
			<Route index />
			<Route path=':pageIdentifier' />
		</Route>
		
		<Route path='*' element={<NotFound />} />
	</Route>
);

export default appRoutes;
